export default
    {
        path: "/eventInfo",
        component: () => import('../view/eventInfo/eventInfo.vue'),
        children: [
            {
                path: "eventMainIndex",
                name: 'eventMainIndex',
                component: () => import('../view/eventInfo/eventMainIndex.vue'),
                props: (route) => (
                    {
                        token:route.query.token,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                    }
                )
            },
            {
                path: "eventListIndex",
                name: 'eventListIndex',
                component: () => import('../view/eventInfo/eventListIndex.vue'),
            },
            {
                path: "eventDetailIndex",
                name: 'eventDetailIndex',
                component: () => import('../view/eventInfo/eventDetailIndex.vue'),
            },
            // {
            //     path: "hisInfoAuthor",//历史资料库授权
            //     name: 'hisInfoAuthor',
            //     component: () => import('../view/eventInfo/hisInfoAuthor.vue'),
            //     props: (route) => (
            //         {
            //             token:route.query.token,
            //             koaToken:route.query.koaToken,
            //             userId:route.query.userId,
            //             deviceType:route.query.deviceType
            //         }
            //     ),

            // },
        ]

    }



// WEBPACK FOOTER //
// ./src/router/eventInfoRouter.js